import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00ddf394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-table" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "page-table-body" }
const _hoisted_5 = { class: "table-main" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "time" }, "発表日時", -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "table-main" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<ul class=\"legends flex\" data-v-00ddf394><li class=\"legend legend-heading\" data-v-00ddf394>凡例</li><li class=\"legend legend-item\" data-v-00ddf394><span class=\"legend-swatch level-5\" data-v-00ddf394></span><span class=\"legend-label\" data-v-00ddf394>レベル5特別警報、特別警報</span></li><li class=\"legend legend-item\" data-v-00ddf394><span class=\"legend-swatch level-4\" data-v-00ddf394></span><span class=\"legend-label\" data-v-00ddf394>レベル4危険警報</span></li><li class=\"legend legend-item\" data-v-00ddf394><span class=\"legend-swatch level-3\" data-v-00ddf394></span><span class=\"legend-label\" data-v-00ddf394>レベル3警報、警報</span></li><li class=\"legend legend-item\" data-v-00ddf394><span class=\"legend-swatch level-2\" data-v-00ddf394></span><span class=\"legend-label\" data-v-00ddf394>レベル2注意報、注意報</span></li><li class=\"legend legend-item\" data-v-00ddf394><span class=\"legend-mark cancel\" data-v-00ddf394>✕</span><span class=\"legend-label\" data-v-00ddf394>解除</span></li></ul>", 1)

import { ref, computed, watch } from 'vue'
import moment from 'moment'
import { useWeatherWarningHistoryStore } from '@/stores/weatherWarningHistoryStore'
import { WEATHER_WARNING_COLUMNS, WeatherWarningColumn, resolveAlertLevel } from '@/models/weatherWarningCode'
import { WeatherWarningHistory2Item } from '@/models/WeatherWarningHistory2'
import { ALERT_KIND_STATUSES } from '@/models/WeatherWarning'
import { useInitDataStore } from '@/stores/initDataStore'
import { Area } from '@/models/WeatherWarning'

// 発令中＝■（レベル色）、解除＝✕（グレー）

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ISSUED_MARK = '■'
const CANCEL_MARK = '✕'

const initDataStore = useInitDataStore()
const weatherWarningHistoryStore = useWeatherWarningHistoryStore()
const areaCode = ref(initDataStore.initData.definitionInfo.alerts.common.areaInfo[0].code)
const tableBodyHeight = ref(window.innerHeight - 300)

const optionsForArea = computed(() => {
  const areaList = initDataStore.initData.definitionInfo.alerts?.common?.areaInfo || []

  return areaList.map((area: Area) => ({ label: area.name, value: area.code }))
})

const historyItems = computed(() => {
  return weatherWarningHistoryStore.weatherWarningHistory.weatherWarningData
})

// 種別列に一致する kind を選ぶ。氾濫など複数（複数河川）が同時に存在し得るため、
// 発令中を優先し、その中で最も警戒レベルが高いものを採用する（全て解除なら最高レベルの解除）
const getKind = (item: WeatherWarningHistory2Item, column: WeatherWarningColumn) => {
  const matched = item.kinds.filter(kind => column.codes.includes(kind.code))

  if (matched.length === 0) {
    return undefined
  }

  const active = matched.filter(kind => kind.status !== ALERT_KIND_STATUSES.CANCEL)
  const candidates = active.length > 0 ? active : matched

  return candidates.reduce((highest, kind) =>
    resolveAlertLevel(kind.code) > resolveAlertLevel(highest.code) ? kind : highest
  )
}

// 発令中・解除のみ表示。解除＝✕、それ以外（発表・継続など）＝■
const getCellMark = (item: WeatherWarningHistory2Item, column: WeatherWarningColumn) => {
  const kind = getKind(item, column)

  if (!kind) {
    return ''
  }

  return kind.status === ALERT_KIND_STATUSES.CANCEL ? CANCEL_MARK : ISSUED_MARK
}

// 解除＝グレー、発令中＝コード辞書のレベルに応じた色（level-2〜5）
const getCellClass = (item: WeatherWarningHistory2Item, column: WeatherWarningColumn) => {
  const kind = getKind(item, column)

  if (!kind) {
    return ''
  }

  if (kind.status === ALERT_KIND_STATUSES.CANCEL) {
    return 'cancel'
  }

  return `level-${resolveAlertLevel(kind.code)}`
}

const formatTime = (time: string) => {
  return moment(time).format('MM/DD HH:mm')
}

const formatHeadText = (text: string) => {
  return Array.from(text)
    .map(c => c)
    .join('<br />')
}

const tableBodyWrapperStyle = computed(() => {
  return `height: ${tableBodyHeight.value}px`
})

window.addEventListener('resize', () => {
  tableBodyHeight.value = window.innerHeight - 300
})

watch(
  () => areaCode.value,
  () => {
    weatherWarningHistoryStore.fetch(areaCode.value.toString())
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_udc_select = _resolveComponent("udc-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_udc_select, {
          modelValue: areaCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((areaCode).value = $event)),
          options: _unref(optionsForArea),
          "chobo-style": "search"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEATHER_WARNING_COLUMNS), (column) => {
              return (_openBlock(), _createElementBlock("td", {
                key: column.name,
                innerHTML: formatHeadText(column.name),
                class: "label"
              }, null, 8, _hoisted_7))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle(_unref(tableBodyWrapperStyle)),
        class: "table-body-wrapper"
      }, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyItems), (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.targetTime
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(formatTime(item.targetTime)), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEATHER_WARNING_COLUMNS), (column) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: column.name,
                    class: _normalizeClass([getCellClass(item, column), "value"])
                  }, _toDisplayString(getCellMark(item, column)), 3))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ], 4),
      _hoisted_10
    ])
  ]))
}
}

})